import styled from "@emotion/styled";

const Img = styled.img<{ circle?: boolean; rounded?: boolean }>(
  ({ circle = false, rounded = false }) => ({
    width: "100%",
    ...(rounded && {
      borderRadius: 4,
    }),
    ...(circle && {
      aspectRatio: "1 / 1",
      borderRadius: 999,
      objectFit: "cover",
    }),
  })
);

export { Img };
